var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxSearchAlt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33464 15C9.81378 14.9997 11.2503 14.5045 12.4155 13.5933L16.0788 17.2566L17.2571 16.0783L13.5938 12.415C14.5055 11.2497 15.0009 9.81282 15.0013 8.33329C15.0013 4.65746 12.0105 1.66663 8.33464 1.66663C4.6588 1.66663 1.66797 4.65746 1.66797 8.33329C1.66797 12.0091 4.6588 15 8.33464 15ZM8.33464 3.33329C11.0921 3.33329 13.3346 5.57579 13.3346 8.33329C13.3346 11.0908 11.0921 13.3333 8.33464 13.3333C5.57714 13.3333 3.33464 11.0908 3.33464 8.33329C3.33464 5.57579 5.57714 3.33329 8.33464 3.33329Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51131 7.15503C9.82715 7.4717 10.0013 7.89003 10.0013 8.33336H11.668C11.6687 7.89539 11.5826 7.46161 11.4147 7.0571C11.2468 6.65259 11.0003 6.28538 10.6896 5.9767C9.42798 4.7167 7.24048 4.7167 5.97964 5.9767L7.15631 7.1567C7.78965 6.52503 8.88131 6.5267 9.51131 7.15503Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxSearchAlt);
export default __webpack_public_path__ + "static/media/bx-search-alt.bc5a0c9ce70a183d49f1f79f9a41e138.svg";
export { ForwardRef as ReactComponent };